(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[918],{

/***/ 5081:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[site]/model/[modelSlug]",
      function () {
        return __webpack_require__(7432);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_ModelPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5640);
/* harmony import */ var _helpers_uppercaseFirst__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(406);





function ModelQuery(props) {
    var title = props.title, site = props.site, boardType = props.boardType, boardSlug = props.boardSlug, modelSlug = props.modelSlug;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ModelPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        url: "/".concat(site, "/").concat(boardType, "/").concat(boardSlug, "/").concat(modelSlug),
        title: "".concat(title).concat(boardType ? " | ".concat((0,_helpers_uppercaseFirst__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(boardType)) : "")
    }));
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ModelQuery);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [333,216,816,640,774,888,179], function() { return __webpack_exec__(5081); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);